import styled from 'styled-components'

import { breakpoints, colors } from '@/styles'
import { H5 } from '@/components/text'

const FormTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
  margin-bottom: 16px;
`

type TitleProps = {
  text: React.ReactNode
  children?: React.ReactNode
}

export const FormTitle: React.FC<TitleProps> = ({ text, children = null }) => (
  <FormTitleWrapper>
    <H5>{text}</H5>
    {children}
  </FormTitleWrapper>
)

export const FormCard = styled.div<{ gapX?: string; gapY?: string }>`
  background-color: ${colors.white};
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  width: 100%;
  margin: 0 0 32px;
  padding: 24px;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06);
  gap: ${props => `${props.gapY || 0} ${props.gapX || 0}`};

  @media (max-width: ${breakpoints.ipadMiniMax}) {
    padding: 16px;
  }
`

export const FormCardInnerRow = styled.div<{ divider?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;

  div {
    font-weight: 500;
  }

  div:last-of-type {
    color: ${colors.grey56};
  }

  ${props =>
    props.divider &&
    `
    && {
      padding-top: 12px;
      border-top: 1px solid ${colors.grey};
      margin-bottom: 0;
      > div {
        font-weight: 700;
        color: ${colors.black};
      }
    }
  `};
`

export const FormCardInner = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${colors.grey96};
  border-radius: 8px;
  padding: 16px;
  gap: 16px 0;

  &[aria-hidden='true'] {
    display: none;
  }
`
